/**
 * Stale chunk after a deploy (sweep 2026-09-15: 93 404s for old /assets/*.js
 * in a week). The real fix is the service worker waiting for Reload (sw.ts):
 * an open tab keeps its own build's chunks in the old worker's precache. This
 * covers the tabs that worker does not serve — no service worker, a bypassed
 * one, a heuristically cached index.html — where a lazy route or sheet asks
 * for a chunk the build-loop already deleted.
 *
 * Vite fires `vite:preloadError` when a dynamic import fails. Reload once onto
 * the current build instead of showing "Something went wrong". The timestamp
 * guard means a chunk that is genuinely missing reaches the error page rather
 * than reloading forever; a later deploy (a minute on) can reload again. With
 * sessionStorage blocked there is no way to stop a loop, so it never reloads.
 */
const KEY = 'demoops:preload-reloaded-at';
const WINDOW_MS = 60_000;

export function installPreloadRecovery(win: Window = window, now: () => number = Date.now): void {
  win.addEventListener('vite:preloadError', (event) => {
    try {
      const last = Number(win.sessionStorage.getItem(KEY) ?? 0);
      if (last && now() - last < WINDOW_MS) return;
      win.sessionStorage.setItem(KEY, String(now()));
    } catch {
      return;
    }
    event.preventDefault();
    win.location.reload();
  });
}
